var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15293_10503)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2223 8.00005C14.2223 11.4365 11.4365 14.2223 8.00005 14.2223C4.56362 14.2223 1.77783 11.4365 1.77783 8.00005C1.77783 4.56362 4.56362 1.77783 8.00005 1.77783C11.4365 1.77783 14.2223 4.56362 14.2223 8.00005ZM10.9535 11.8963C10.133 12.5193 9.1097 12.8889 8.00005 12.8889C5.3 12.8889 3.11117 10.7001 3.11117 8.00005C3.11117 6.89041 3.48085 5.8671 4.10378 5.04659L10.9535 11.8963ZM11.8963 10.9535L5.04659 4.10378C5.8671 3.48085 6.89041 3.11117 8.00005 3.11117C10.7001 3.11117 12.8889 5.3 12.8889 8.00005C12.8889 9.1097 12.5193 10.133 11.8963 10.9535Z",
    fill: "#121922"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15293_10503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/iconCancel.2c2f5ee67446a3ba7425bc1e1732d3f0.svg";
export { ForwardRef as ReactComponent };